<div class="step-panel step-panel-compact step-panel-instituciones step-panel-equipo">
  <h3>Instituciones</h3>
  <p class="step-intro">Define la institucion patrocinante y la unidad que respalda la postulacion. Esto nos deja la estructura clara para concursos con participacion institucional.</p>

  <div class="section-block">
    <h4>Agregar institucion</h4>

    <div class="form-grid">
      <label class="field">
        <span>Institucion</span>
        <input type="text" [(ngModel)]="institucionNueva.nombreInstitucion" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Unidad institucional</span>
        <input type="text" [(ngModel)]="institucionNueva.unidadInstitucional" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Departamento / Facultad</span>
        <input type="text" [(ngModel)]="institucionNueva.departamentoFacultad" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Tipo de institucion</span>
        <select [(ngModel)]="institucionNueva.rol" [disabled]="soloLectura">
          <option value="principal">Principal</option>
          <option value="asociada">Secundaria</option>
        </select>
      </label>

      <div class="field field-actions">
        <span>Accion</span>
        <button type="button" class="invite-button" (click)="agregarInstitucion()" [disabled]="!puedeAgregarInstitucion">
          Agregar institucion
        </button>
      </div>
    </div>
  </div>

  <div class="records-box section-block">
    <div class="records-head">
      <h4>Registro de instituciones</h4>
      <p>Quedan visibles en esta misma vista para seguimiento institucional de la postulacion.</p>
    </div>

    <div class="records-list" *ngIf="formulario.instituciones.length > 0; else sinInstitucionesTpl">
      <article class="record-card" *ngFor="let institucion of formulario.instituciones; let i = index">
        <div class="record-top">
          <strong>{{ etiquetaInstitucion(institucion, i) }}</strong>
          <div class="record-actions">
            <span class="status-pill" [ngClass]="claseTipoInstitucion(institucion.rol)">
              {{ etiquetaTipoInstitucion(institucion.rol) }}
            </span>
            <button type="button" class="btn-secondary btn-small" *ngIf="institucion.rol !== 'principal'" (click)="eliminarInstitucion(i)" [disabled]="soloLectura">
              Eliminar
            </button>
          </div>
        </div>

        <div class="record-grid">
          <div><span>Institucion:</span> {{ institucion.nombreInstitucion || '-' }}</div>
          <div><span>Unidad:</span> {{ institucion.unidadInstitucional || '-' }}</div>
          <div><span>Departamento / Facultad:</span> {{ institucion.departamentoFacultad || '-' }}</div>
        </div>
      </article>
    </div>

    <ng-template #sinInstitucionesTpl>
      <div class="placeholder-box records-empty">
        Aun no se registran instituciones para la postulacion.
      </div>
    </ng-template>
  </div>
</div>
